import Vue from 'vue'
import './plugins/vuetify'
import Vuetify from 'vuetify'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import mixin from './components/mixin.js'
import VeeValidate from 'vee-validate';
import { Validator } from 'vee-validate';
import dialogEditItem from './components/dialogEditItem'
import dialogEditItemMobile from './components/dialogEditItemMobile'

const dict = {
  custom: {
    cantidad:{
      min_value: 'La cantidad no puede ser menor que 0'
    },
    precio:{
      min_value: 'El precio no puede ser menor que 0'
    },
    dto: {
      max_value: 'El descuento no puede ser mayor que 100',
      min_value: 'El descuento no puede ser menor que 0'
    }
  }
};
Validator.localize('en', dict);

Vue.use(VueAxios, axios);
Vue.use(VeeValidate);
Vue.use(Vuetify, {
  theme: {
    primary: '#3aa338',
    secondary: '#cc6600',
  }
})

Vue.config.productionTip = false

//Vue.prototype.ApiBaseUrl = 'http://185.254.206.254:8085/SlimVue/';
Vue.prototype.ApiBaseUrl = 'https://b2b.tadiscan.es:8095/SlimVue/';

//Vue.prototype.ApiBaseUrlNETCore = 'http://localhost:5000/';
//Vue.prototype.ApiBaseUrlNETCore = 'http://185.254.206.254/api/';
//Vue.prototype.ApiBaseUrlNETCore = 'https://b2b.tadiscan.es/api/';
//Vue.prototype.ApiBaseUrlNETCore = process.env.NODE_ENV == 'production' ? 'https://b2b.tadiscan.es/api/' : 'http://localhost:5000/';
Vue.prototype.ApiBaseUrlNETCore = process.env.NODE_ENV == 'production' ? '/api/' : 'http://localhost:5000/';
//Vue.prototype.PicturesURL = 'http://185.254.206.254:8085/IM%C3%81GENES%20TADISCAN/';
Vue.prototype.PicturesURL = 'https://b2b.tadiscan.es/IM%C3%81GENES%20TADISCAN/';

Vue.prototype.PrintDocsFolder =  'http://localhost/app/printdocs/'
Vue.component('dialogEditItem', dialogEditItem);
Vue.component('dialogEditItemMobile', dialogEditItemMobile);

//Vue.prototype.ApiBaseUrl = 'http://81.45.176.9:36005/QSMSlimDES/';
//Vue.prototype.ApiBaseUrlNETCore = 'http://81.45.176.9:36001/';

//Cargando asi el mixin queda como global y accesible desde toda la app
Vue.mixin(mixin);

new Vue({
  router,
  store,
  icons: {
    iconfont: 'mdi', // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg'
  },
  render: h => h(App)
}).$mount('#app')
